const testimonials = [
  {
    name: "David M.",
    location: "Viera, FL",
    rating: 5,
    text: "I'm a systems engineer at Northrop Grumman and got called to support a satellite payload integration in French Guiana with twelve days' notice. Pulled my passport and it was expired. Fast Passport Center had my renewal processed in four business days. I made the launch campaign, the payload integrated on schedule, and I didn't miss a single day on-site. Absolutely clutch service for aerospace professionals.",
    service: "Emergency Passport Renewal",
  },
  {
    name: "Lisa R.",
    location: "Melbourne Beach, FL",
    rating: 5,
    text: "We booked a Disney cruise from Port Canaveral for spring break — our kids had been counting down for months. Two weeks before sailing, we discovered my daughter's passport had expired. We were devastated. Fast Passport Center expedited her renewal and we had it back in five business days. We made the cruise, the kids met every princess, and we didn't lose a dime. I've told every parent at my daughter's school about this service.",
    service: "Child Passport Renewal",
  },
  {
    name: "Tom S.",
    location: "Satellite Beach, FL",
    rating: 5,
    text: "Surf trip to Costa Rica — a friend called with an open spot at a lodge in Tamarindo leaving in nine days. Checked my passport, expired eight months ago while I was working remotely and not traveling. Fast Passport Center came through in three business days with the renewal. Caught overhead waves at Playa Grande and watched the sunset from the lodge porch. Unreal turnaround.",
    service: "Expedited Passport Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function MelbourneTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Melbourne Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Melbourne aerospace engineers, cruise families, surfers, and beachside residents who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}